import { render, staticRenderFns } from "./DoctorStartOfWork.vue?vue&type=template&id=90d86dcc&"
import script from "./DoctorStartOfWork.vue?vue&type=script&lang=js&"
export * from "./DoctorStartOfWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports